<template>
  <div class="payment-page">
    <div class="container payment-page-header">
      <div class="row">
        <div class="col-lg-3 col-md-2 col-sm-1"></div>
        <div class="col-lg-6 col-md-8 col-sm-10 logo-area">
          <img src="../assets/toplogo-infopage.png" height="70" alt="" />
        </div>
        <div class="col-lg-3 col-md-2 col-sm-1"></div>
      </div>
    </div>

    <div class="navbar navbar-inverse navbar-fixed-top hide"></div>
    <div class="container body-content">
      <div class="row">
        <div class="col-lg-3 col-md-2 col-sm-1"></div>
        <div class="col-lg-6 col-md-8 col-sm-10 main-content">
          <!-- 主要內容 -->
          <!-- 訂單編號 + 訂單名稱 -->
          <div>
            <span class="badge badge-list-id">購買內容確認 </span>
          </div>
          <div class="top-payment-info">
            <p class="total-price">
              {{
                Sample.SampleDetail == null
                  ? ""
                  : Sample.SampleDetail.SampleName
              }}

              <!-- @Model.SampleDetail.SampleName -->
            </p>
          </div>

          <!-- 單筆訂單內容 -->
          <div class="payment-info-outer">
            <div class="payment-info">
              <div class="sub-title-gray-box">
                <div class="user-cir-icon">
                  <i class="fas fa-user"></i>
                </div>
                單筆訂單資料
              </div>

              <!-- 購買的課程 -->
              <div
                class="item-list"
                v-for="(ocls, index) in CurrentOcls"
                :key="index"
              >
                <p class="class-name">{{ ocls.classname }}</p>
                <div class="class-id">
                  <span>{{ ocls.classid }}</span>
                </div>
                <!-- 各項收支 -->
                <div class="item-pay">
                  <div>
                    <i class="fas fa-dollar-sign"></i> <span>學費</span>
                  </div>
                  <div class="item-pay-info-mobile">
                    <span>金額</span
                    ><span class="price">{{ ocls.subtotal }}</span>
                  </div>
                </div>
                <div class="item-pay-info">
                  <div class="gray-arrow"></div>
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <span>原價</span>
                          <p>{{ ocls.originalPrice }}</p>
                        </td>
                        <td>
                          <span>折數</span>
                          <p>{{ ocls.discount }}</p>
                        </td>
                        <td>
                          <span>數量</span>
                          <p>{{ ocls.quantity }}</p>
                        </td>
                        <td>
                          <span>折扣</span>
                          <p>{{ ocls.amountDisc }}</p>
                        </td>
                        <td class="item-pay-info-price">
                          <span>金額</span>
                          <p>{{ ocls.subtotal }}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /各項收支 -->
              </div>
            </div>
          </div>

          <div class="footer-payment-info check-page">
            <p>人數選擇</p>
            <b-form-select
              v-model="StudentCount"
              :options="Sample.StudentRange"
              style="max-width: 100px; margin-left: 10px; margin-bottom: 10px"
              size="sm"
              class="form-select form-control"
            ></b-form-select>
          </div>

          <div class="footer-payment-info check-page">
            <p>單筆金額</p>
            <p class="total-price">
              <span> {{ SubTotal }}</span> 元
            </p>
          </div>
          <div class="footer-payment-info check-page">
            <p>報名學員（訂單數量） x</p>
            <p class="total-price">
              <span> {{ StudentCount }}</span>
            </p>
          </div>
          <div class="footer-payment-info check-page">
            <p>所有訂單總額</p>
            <p class="total-price"><span> </span> {{ total }} 元</p>
          </div>
          <div class="row user-info-input-title-area">
            <p class="col-xs-12">學員資料</p>
          </div>

          <!-- <div>
            {{ $v.StudentsData.$each.$iter }}
          </div> -->
          <!-- 個人資料 -->
          <div
            class="row user-info-input"
            v-for="(student, index) in $v.StudentsData.$each.$iter"
            :key="index"
          >
            <div class="col-xs-2">
              <div class="user-no">
                <i class="fas fa-user"></i> #<span>{{
                  parseInt(index) + 1
                }}</span>
              </div>
            </div>

            <div class="col-xs-7"></div>
            <div class="col-xs-3">
              <b-link @click="goSSO(index)">登入會員資料</b-link>
            </div>

            <div class="col-xs-6">
              <label for="user-name-1"
                >學員姓名
                <span v-if="!student.Name.required" style="color: red">
                  *
                </span>
              </label>

              <input
                type="text"
                class="form-control"
                v-model="student.Name.$model"
              />
            </div>

            <div class="col-xs-6">
              <label for="user-gender-1">性別</label>
              <select
                v-model="student.Sex.$model"
                class="form-control form-select"
              >
                <option value="M">男</option>
                <option value="F">女</option>
              </select>
            </div>

            <div class="col-xs-6">
              <label for="user-id-1"
                >身分證號
                <span v-if="!student.Ident.required" style="color: red">
                  *
                </span>
              </label>
              <input
                type="text"
                class="form-control"
                v-model="student.Ident.$model"
              />
            </div>

            <div class="col-xs-6">
              <label for="user-id-1">
                生日
                <span v-if="!student.Birth.required" style="color: red">
                  *
                </span>
              </label>
              <div class="row">
                <div class="col-xs-12">
                  <div>
                    <input
                      type="date"
                      class="mb-3 form-control"
                      v-model="student.Birth.$model"
                      min="1900-01-01"
                      :max="datenow"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xs-6">
              <label for="user-tel-1"
                >聯絡電話

                <span v-if="!student.Mobile.required" style="color: red">
                  *
                </span>
              </label>
              <input
                type="text"
                class="form-control"
                v-model="student.Mobile.$model"
              />
            </div>
            <div class="col-xs-6">
              <label for="user-email-1"
                >e-mail

                <span v-if="!student.EMail.required" style="color: red">
                  *
                </span>
              </label>
              <input
                type="text"
                class="form-control"
                v-model="student.EMail.$model"
              />
            </div>

            <div class="col-xs-6">
              <label for="user-tel-1">統編 </label>
              <input
                type="text"
                class="form-control"
                v-model="student.BuyerId.$model"
              />
            </div>
            <div class="col-xs-6">
              <label for="user-email-1">抬頭 </label>
              <input
                type="text"
                class="form-control"
                v-model="student.BuyerName.$model"
              />
            </div>

            <div class="col-xs-12" style="margin-top: 10px">
              <input
                type="text"
                class="form-control"
                v-model="student.Memo.$model"
                placeholder="備註"
              />
            </div>
          </div>

          <div class="checked-list-btn-area" v-if="SignUpCheck">
            <button
              class="checked-list btn"
              type="button"
              @click="CompleteOreg()"
            >
              <i class="fas fa-check-circle"></i>
              確認訂單
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row payment-page-footer">
        <div class="col-lg-3 col-md-2 col-sm-1"></div>
        <div class="col-lg-6 col-md-8 col-sm-10 web-right">
          © 中國文化大學推廣教育部 School of Continuing Education, Chinese
          Culture University. All Rights Reserved.
        </div>
        <div class="col-lg-3 col-md-2 col-sm-1"></div>
      </div>
    </div>

    <div class="col-lg-3 col-md-2 col-sm-1"></div>

    <!-- 建立訂單按鈕 -->
    <!-- @if (Model.SampleDetail.OclsSamples != null && Model.SampleDetail.Status == "on" && (Model.SampleDetail.STime < DateTime.Now && Model.SampleDetail.ETime > DateTime.Now))
    {

        @Html.HiddenFor(model => model.SampleDetail.SampleCode)
        @Html.HiddenFor(c => c.SampleDetail.SampleNo)
        <div class="checked-list-btn-area">
            <button class="checked-list btn" type="submit">
                <i class="fas fa-check-circle"></i>
                確認訂單
            </button>
        </div>
    } -->
  </div>
</template>

<script>
// @ is an alias to /src

import { OregSample, SignUpWithSample } from "../api/api.js";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import "../content/payment-page.css";
import "../content/bootstrap.min.css";

export default {
  name: "Home",
  data() {
    return {
      Sample: {},
      CurrentOcls: [],
      StudentCount: 0,
      SubTotal: 0,
      memb_no: 0,
      StudentModel: {
        Name: "",
        Ident: "",
        Mobile: "",
        EMail: "",
        Sex: "M",
        Birth: "",
        Month: 1,
        Year: 2000,
        Day: 1,
        Memo: "",
        BuyerId: "",
        BuyerName: "",
      },
      StudentsData: [],
    };
  },
  props: ["SampleKey"],
  validations() {
    const model = {
      StudentsData: {
        $each: {
          Name: { required },
          Ident: { required },
          Mobile: { required },
          EMail: { required },
          Birth: { required },
          Memo: {},
          Sex: { required },
          BuyerId: {},
          BuyerName: {},
        },
      },
    };

    return model;
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    window.addEventListener("storage", this.handleStorageChange);
    OregSample(this.SampleKey).then((c) => {
      this.Sample = c.data;
      this.StudentCount = Math.min.apply(Math, this.Sample.StudentRange);
      this.RefreshOcls(this.StudentCount);
    });
  },

  watch: {
    StudentCount: function(n, o) {
      this.RefreshOcls(n);

      if (o - n > 0) {
        this.StudentsData.splice(n, o - n);
      } else if (n - o > 0) {
        for (let index = 0; index < n - o; index++) {
          this.pushStudentModel();
        }
      }
    },
  },
  computed: {
    total() {
      return this.SubTotal * this.StudentCount;
    },
    years() {
      const year = new Date().getFullYear();
      return Array.from({ length: 100 }, (value, index) => year - index + 1);
    },
    months() {
      return Array.from({ length: 12 }, (value, index) => index + 1);
    },
    days() {
      return Array.from({ length: 31 }, (value, index) => index + 1);
    },
    datenow() {
      return moment(new Date()).format("YYYY-MM-DD");
    },
    SignUpCheck() {
      if (typeof this.Sample.SampleDetail !== "undefined") {
        var now = this.$moment(new Date()).format("YYYYMMDDHHmmss");

        var check =
          this.Sample.SampleDetail.Status == "on" &&
          this.$moment(this.Sample.SampleDetail.STime).format(
            "YYYYMMDDHHmmss"
          ) <= now &&
          this.$moment(this.Sample.SampleDetail.ETime).format(
            "YYYYMMDDHHmmss"
          ) >= now;

        if (!check) {
          alert("此報名已結束！");
        }
        return check;
      }

      return false;
    },
  },
  beforeDestroy() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  methods: {
    handleBeforeUnload() {
      localStorage.clear();
    },
    RefreshOcls(students) {
      this.CurrentOcls = this.Sample.SampleDetail.OclsSamples.filter(
        (c) => students >= c.MinStudent && students <= c.MaxStudent
      );
      this.SubTotal = this.CurrentOcls.reduce(
        (acc, item) => acc + item.subtotal,
        0
      );
    },
    goSSO(no) {
      this.memb_no = no;
      const p = this.$router.resolve({
        name: "Member",
        params: {
          no: this.memb_no,
        },
      }).href;

      const fullPath = encodeURIComponent(
        window.location.origin + window.location.pathname + "/" + p
      );

      var href = ` https://m.sce.pccu.edu.tw/login?trnurl=${fullPath}`;
      window.open(href, "", "width=800,height=600,left=200,top=200");
    },
    formats(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    pushStudentModel() {
      this.StudentsData.push({
        Name: "",
        Ident: "",
        Mobile: "",
        EMail: "",
        Sex: "M",
        Birth: "",
        Memo: "",
        BuyerId: "",
        BuyerName: "",
      });
    },
    handleStorageChange(event) {
      if (event.key === "mem" + this.memb_no) {
        Object.assign(
          this.StudentsData[this.memb_no],
          JSON.parse(event.newValue)
        );
        localStorage.removeItem("mem" + this.memb_no);
      }
    },
    CompleteOreg() {
      if (this.$v.$invalid) {
        alert("有資料尚未填完!");
      } else {
        if (this.SignUpCheck) {
          this.Sample.Students = this.StudentsData;

          SignUpWithSample(this.Sample).then((c) => {
            if (c.data != 0) {
              window.location.href =
                "https://scepayment.sce.pccu.edu.tw/payweb/info/?orderid=GROUP" +
                c.data;
            } else {
              alert("發生錯誤！有可能是報名時間已結束！");
            }
          });
        }
      }
    },
  },
};
</script>
